import { getClerkAuthToken } from './clerk';
import { ENV_VARS } from './env';

/*********************************
 * Pick the network call that best matches your needs
 *************************************************************/

// Post JSON data, return a response
export async function postJson(path: string, body = {}, authed = true): Promise<Response> {
  let headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (authed) {
    headers = await toApiHeaders({ 'Content-Type': 'application/json' });
  }
  return fetch(toApiUrl(path), {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body),
  });
}

// Post JSON data, return parsed JSON
export async function fetchJson<T = any>(path: string, body = {}, authed = true): Promise<T> {
  return postJson(path, body, authed).then((res) => res.json());
}

// Post JSON data, return CSV as text
export async function fetchCsv(path: string, body = {}): Promise<string> {
  return postJson(path, body).then((res) => res.text());
}

/*********************************
 * Helper functions for constructing the parts needed in the API request
 ****************************************************************************/

function toApiUrl(path: string) {
  const isDev = process.env.NODE_ENV === 'development';
  const port = isDev ? ENV_VARS.VITE_EXPRESS_PORT : '3000';
  return isDev ? `http://${window.location.hostname}:${port}/${path}` : `/${path}`;
}

async function toApiHeaders(headers: Record<string, string> = {}) {
  const token = await getClerkAuthToken();
  return { authorization: `Bearer ${token}`, ...headers };
}
